<template>
	<div class="bg">
		<!-- 搜索栏 -->
		<div class="top_search_part">
			<div class="search_box">
				<div class="search_item"><el-input v-model="deliveryManName" :placeholder="$t('message.deliveryNameTitle')"></el-input></div>
				<div class="search_item">
					<el-select v-model="deliveryArea" multiple filterable :placeholder="$t('message.deliveryAreaTitle')">
						<el-option v-for="item in areaList" :key="item.JPNUM" :label="item.JPNAME" :value="item.JPNAME"></el-option>
					</el-select>
				</div>
				<div class="search_item">
				  <el-date-picker
				    v-model="attendanceTime"
				    type="datetimerange"
				    range-separator=" - "
				    :start-placeholder="$t('message.attendanceTimeTitle') + $t('message.orderTimeStartHolder')"
				    :end-placeholder="$t('message.attendanceTimeTitle') + $t('message.orderTimeEndHolder')"
				    value-format="yyyy-MM-dd HH:mm:ss">
				  </el-date-picker>
				</div>
				<div class="search_item">
				  <el-select  v-model="ISExternalDRIVER" style="margin-right: 10px;">
				  	<el-option label="全部" value=""></el-option>
				  	<el-option label="外部司机" value="1"></el-option>
				  	<el-option label="不是外部司机" value="0"></el-option>
				  </el-select>
				</div>
				<div class="search_btn" @click="searchDeliveryName">{{ $t('message.searchBtnText') }}</div>
			</div>
<!-- 
 
 
 -->
		</div>
		<!-- 搜索栏 -->
		<!-- 配送员列表 -->
		<div class="content">
			<div class="tableBox">
				<el-table
					id="deliveryMenList"
					:data="deliveryMenList"
					style="width: 100%"
					stripe
					size="small"
					header-cell-class-name="tableHeader"
					cell-class-name="tableBodyer"
					height="100%"
				>
					<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
					<el-table-column :label="$t('message.deliveryAccountTitle')" prop="UINPUTNAME"></el-table-column>
					<el-table-column :label="$t('message.deliveryNameTitle')" prop="USHOWNAME"></el-table-column>
					<el-table-column :label="$t('message.deliveryPasswordTitle')" prop="password"></el-table-column>
					<el-table-column :label="$t('message.deliveryAreaTitle')" prop="PEISONGFANWEI" show-overflow-tooltip></el-table-column>
					<el-table-column :label="$t('message.deliveryPhoneTitle')" prop="TELPHONE" min-width="120"></el-table-column>
					<el-table-column :label="$t('message.deliveryEmailTitle')" prop="EMAIL" min-width="150"></el-table-column>
					<el-table-column :label="$t('message.IsExternalSiJi')"  width="120">
					  <template slot-scope="scope">
					  	<span  >{{scope.row.WBSJ|IsExternalDriver}}</span>
					  </template>
					</el-table-column>
					<el-table-column :label="$t('message.attendanceNumTitle')" prop="cqcs" width="140"></el-table-column>
					<el-table-column :label="$t('message.attendanceHoursTitle')" prop="zgs" width="140"></el-table-column>
					<el-table-column :label="$t('message.clockInDetailTitle')" min-width="100" fixed="right">
					  <template slot-scope="scope">
					    <div class="operate_btn_box">
					      <el-button class="operation_btn" type="text" @click.native.prevent="checkDetail(scope.row)">查看</el-button>
					    </div>
					  </template>
					</el-table-column>
					<el-table-column :label="$t('message.customTableTitle5')" width="200" fixed="right">
				
						<template slot-scope="scope">
							<div class="operate_btn_box">
								<el-button class="operation_btn updateBtn" type="text" size="small" @click.native.prevent="updateDelivery(scope.row)"></el-button>
								<el-button class="operation_btn delBtn" type="text" size="small" @click.native.prevent="delDelivery(scope.row)"></el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChange"
				@current-change="currentChange"
				:current-page="page_no"
				:page-sizes="pageSizes"
				:page-size="page_size"
				layout="total, sizes, prev, pager, next"
				:total="totalSize"
				class="tablePage"
			></el-pagination>
		</div>
		<!-- 配送员列表 -->
		<!-- 添加修改配送人员 -->
		<el-dialog :visible.sync="showMaskBox" :title="maskBoxTitle" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="35%">
			<div class="dialog_box">
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.deliveryAccountTitle') }}</span>
						<el-input v-model="deliveryAccount" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.deliveryNameTitle') }}</span>
						<el-input v-model="deliveryName" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.deliveryPasswordTitle') }}</span>
						<el-input v-model="deliveryPassword" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.deliveryAreaTitle') }}</span>
						<el-select v-model="allotArea" multiple filterable :placeholder="$t('message.deliveryAreaTitle')" style="width: 100%;">
							<el-option v-for="item in areaList" :key="item.JPNUM" :label="item.JPNAME" :value="item.JPNAME"></el-option>
						</el-select>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.deliveryPhoneTitle') }}</span>
						<el-input v-model="deliveryPhone" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.deliveryEmailTitle') }}</span>
						<el-input v-model="deliveryEmail" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="showMaskBox = false">{{ $t('message.cancleText') }}</el-button>
					<el-button type="primary" @click="addNewDeliveryMan">{{ $t('message.confirmText') }}</el-button>
				</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getDeliveryArea, getDeliveryMenList, setDeliveryMan, delDeliveryMan } from '@/api/getData.js';
export default {
	name: 'deliveryManage',
	data() {
		return {
			areaList: [],
			deliveryArea: [],
			deliveryMenList: [],
			deliveryManName: '',
			attendanceTime:null,
			page_no: 1,
			page_size: 10,
			pageSizes: [10, 20, 30, 50, 100],
			totalSize: 0,
			showMaskBox: false,
			maskBoxTitle: '',
			newId: 0,
			allotArea: [], // 分配配送范围
			deliveryAccount: '',
			 ISExternalDRIVER: '',
			deliveryName: '',
			deliveryPassword: '',
			deliveryPhone: '',
			deliveryEmail: '',
			zgs:'0',
			zqcs:'0'
		};
	},
	created() {
		let param = this.$store.state.JHSS_formalManage_param
		if (param.PAGE) this.page_no = param.PAGE
		if (param.TYPE) this.page_size = param.TYPE
		if (param.USHOWNAME) this.tempeoraryManName = param.USHOWNAME
		if (param.UADDTIME && param.DADDTIME) this.attendanceTime = [param.UADDTIME, param.DADDTIME]
		this.getDeliveryArea();
	},
	methods: {
		// 获取日本县一级区域

		async getDeliveryArea() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let res = await getDeliveryArea({});
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			console.log(res);
			// console.log(res.data)
			this.areaList = res.data;
			let param = this.$store.state.JHSS_deliveryManage_param;
			if (param.PAGE) this.page_no = param.PAGE;
			if (param.TYPE) this.page_size = param.TYPE;
			if (param.USHOWNAME) this.deliveryManName = param.USHOWNAME;
			if (param.WBSJ) this.ISExternalDRIVER = param.WBSJ;
			if (param.PEISONGFANWEI) this.deliveryArea = param.PEISONGFANWEI.split(',');
			this.getDeliveryMenList(param);
		},
		// 查看打卡明细
		checkDetail (obj) {
			console.log(obj)
		  this.$router.push({ path: '/deliveryClockStatistics', query: { formalInfo: JSON.stringify(obj), attendanceTime: JSON.stringify(this.attendanceTime) } })
		},
		// 搜索配送员名称
		searchDeliveryName(val) {
			this.page_no = 1
			let param = {}
			// 查询客户管理
			if (this.deliveryManName) param.USHOWNAME = this.deliveryManName
			if (this.attendanceTime) {
			  param.UADDTIME = this.attendanceTime[0]
			  param.DADDTIME = this.attendanceTime[1]
			}
			if (this.deliveryArea.length !== 0) {
				param.PEISONGFANWEI = this.deliveryArea.join(',');
			}
			this.getDeliveryMenList(param)
			
			console.log("名称");
		},
		// 申请条数
		sizeChange(val) {
			// console.log(val)
			this.page_size = val;
			this.page_no = 1;
			let param = {};
			if (this.deliveryManName) {
				param.USHOWNAME = this.deliveryManName;
			}
			if (this.deliveryArea.length !== 0) {
				param.PEISONGFANWEI = this.deliveryArea.join(',');
			}
			this.getDeliveryMenList(param);
			console.log("条数");
		},
		// 当前页
		currentChange(val) {
			// console.log(val)
			this.page_no = val;
			let param = {};
			if (this.deliveryManName) {
				param.USHOWNAME = this.deliveryManName;
			}
			if (this.deliveryArea.length !== 0) {
				param.PEISONGFANWEI = this.deliveryArea.join(',');
			}
			this.getDeliveryMenList(param);
			console.log("当前页");
		},
		// 查询配送员列表
		async getDeliveryMenList(param) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			param = param || {};
			param.PAGE = this.page_no;
			param.TYPE = this.page_size;
			param.WBSJ = this.ISExternalDRIVER;
			param.QUERYID = this.$store.state.JHSS.personalUserid;
			let res = await getDeliveryMenList(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			// console.log(res.data)
			this.totalSize = res.data.num;
			let _this = this;
			let index = (this.page_no - 1) * this.page_size;
			this.deliveryMenList = res.data.dt.map(item => {
				item.index = ++index;
				item.password = '******';
				return item;
			});
			this.$store.commit('setDeliveryManageParam', param);
			console.log("列表");
		},
		// 新增配送员
		addNewDelivery() {
			this.maskBoxTitle = this.$t('message.addDeliveryManTitle');
			this.showMaskBox = true;
			this.newId = 0;
			this.deliveryAccount = '';
			this.deliveryName = '';
			this.deliveryPassword = '';
			this.allotArea = [];
			this.deliveryPhone = '';
			this.deliveryEmail = '';
		},
		// 更新配送员
		updateDelivery(obj) {
			this.maskBoxTitle = this.$t('message.updateDeliveryManTitle');
			this.showMaskBox = true;
			this.newId = obj.ID;
			this.deliveryAccount = obj.UINPUTNAME;
			this.deliveryName = obj.USHOWNAME;
			this.deliveryPassword = obj.PASSWORD;
			this.allotArea = obj.PEISONGFANWEI.split(',');
			this.deliveryPhone = obj.TELPHONE;
			this.deliveryEmail = obj.EMAIL;

		},
		// 确定添加或修改配送员
		async addNewDeliveryMan() {
			if (!this.deliveryAccount) {
				this.$message.error(this.$t('message.deliveryAccountTitle'));
			} else if (!this.deliveryName) {
				this.$message.error(this.$t('message.deliveryNameTitle'));
			} else if (!this.deliveryPassword) {
				this.$message.error(this.$t('message.deliveryPasswordTitle'));
			} else if (this.allotArea.length === 0) {
				this.$message.error(this.$t('message.deliveryAreaTitle'));
			} else if (!this.deliveryPhone) {
				this.$message.error(this.$t('message.deliveryPhoneTitle'));
			} else if (!this.deliveryEmail) {
				this.$message.error(this.$t('message.deliveryEmailTitle'));
			} else {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let param = {
					ID: this.newId,
					UINPUTNAME: this.deliveryAccount,
					USHOWNAME: this.deliveryName,
					PASSWORD: this.deliveryPassword,
					PEISONGFANWEI: this.allotArea.join(','),
					TELPHONE: this.deliveryPhone,
					EMAIL: this.deliveryEmail
				};
				// console.log(param)
				let res = await setDeliveryMan(param);
				loading.close();
				if (res.status !== 200) {
					this.$message.error('network error：' + res.status);
					return;
				}
				// console.log(res.data)
				if (res.data.result !== '1') {
					this.$message.error(res.data.message);
				} else {
					this.showMaskBox = false;
					this.getDeliveryMenList();
				}
			}
		},
		// 删除配送员
		delDelivery(obj) {
			this.$confirm(this.$t('message.delDeliveryPrompt'), this.$t('message.promptTitle'), {
				closeOnClickModal: false,
				confirmButtonText: this.$t('message.confirmText'),
				cancelButtonText: this.$t('message.cancleText')
			})
				.then(() => {
					this.del(obj.ID);
				})
				.catch(() => {
					this.$message(this.$t('message.canclePrompt'));
				});
		},
		async del(id) {
			let param = { ID: id };
			let res = await delDeliveryMan(param);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				// this.page_no = 1
				// this.getDeliveryMenList()
				this.searchDeliveryName();
			}
		}
	},
	filters: {
	  
		IsExternalDriver(value) {
		  if (value==="1"){
				return '是'
			}else{
				return '否'
			}
				
		
		}
	}
};
</script>

<style scoped></style>
